import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import {
    Component,
    HostListener,
    Input,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { HomePageService } from "src/app/Services/home-page.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { TranslateService } from "@ngx-translate/core";
import { MenuItems } from "../../../Core/menu/menu-items/menu-items";
import { MarketingService } from "src/app/Services/marketing.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { Subscription } from "rxjs";

@Component({
    selector: "embryo-Menu",
    templateUrl: "./Menu.component.html",
    styleUrls: ["./Menu.component.scss"],
    animations: [
        trigger("indicatorRotate", [
            state("collapsed", style({ transform: "rotate(0deg)" })),
            state("expanded", style({ transform: "rotate(180deg)" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
            ),
        ]),
    ],
})
export class MenuComponent {
    @Input() CategoriesMenu: any;
    @Input() lang: string = "";
    expanded: boolean = false;
    clickedItem: boolean = false;
    topPostion: string = "";
    closeMenu: string = "";
    fakeArray = new Array(8);
    environmentVariables: any;
    loadingMenu: boolean = true;
    testData: any;
    showcards = true;
    isHover = true;
    user: any
    private subscription!: Subscription;
    showChildList: boolean = false;

    constructor(
        public menuItems: MenuItems,
        public router: Router,
        public translate: TranslateService,
        private confgServ: StaticPagesService,
        private homePageService: HomePageService,
        private marketingService: MarketingService,
        public userLoginServies: LoginUsersService,

    ) {
        this.getInitilizingData();

        userLoginServies.getUserDataEmit().subscribe((user) => {
            this.user = user;
         
        
        if (
            (!this.environmentVariables?.ENABLE_MULTI_INVENTORY) ||
            (this.environmentVariables?.ENABLE_MULTI_INVENTORY &&
                (this.environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup == 'both'
                    || this.environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup == 'area') &&
                (this.user?.branch || this.user?.area))
        ) {
            this.getMenuePages();
        }     
    }) 
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        if (
            this.router.url.includes("/en/") ||
            this.router.url.includes("/ar/")
        ) {
            this.showcards = false;
        }
        else {
            this.showcards = true;
        }

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                if (
                    this.router.url.includes("/en/") ||
                    this.router.url.includes("/ar/")
                ) {
                    this.showcards = false;
                } else {
                    this.showcards = true;
                }
            }
        });
    }

    @HostListener("window:scroll", ["$event"])
    onScrollEvent($event: any) {
        if ($event.target.documentElement.scrollTop > 0) {
            this.showcards = false;
        } else if (
            !this.router.url.includes("/en/") &&
            !this.router.url.includes("/ar/")
        ) {
            this.showcards = true;
        }
    }

    getInitilizingData() {
      this.subscription = this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    getMenuePages() {
        this.homePageService.getMenuData().subscribe((res) => {
            if (res.data) {
                this.testData = res.data;
                this.testData.level1 = this.testData.level1.map((levelOneItem: any) => {
                    levelOneItem.level2 = levelOneItem.level2.map((levelTwoItem: any) => {
                        if (!levelTwoItem.id) {
                            levelTwoItem.slug = levelTwoItem.link.replaceAll('/', '-').toLowerCase();
                        }
                        return levelTwoItem;
                    })
                    return levelOneItem;
                })
                this.updateColorsTest();
                this.subscription.unsubscribe();
            }
            this.loadingMenu = false;
        });
    }

    onItemSelected(item: any) {
        if (item.children && item.children.length)
            this.expanded = !this.expanded;
    }

    updateColorsTest() {
        this.testData["menu_background_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-background-color",
                  this.testData["menu_background_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-background-color",
                  "--second-color"
              );
        this.testData["level2_seprator_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level2-seprator-color",
                  this.testData["level2_seprator_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level2-seprator-color",
                  "--second-color"
              );
        this.testData["label_text_backround_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-label-background",
                  this.testData["label_text_backround_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-label-background",
                  "--second-color"
              );
        this.testData["label_text_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-label-color",
                  this.testData["label_text_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-label-color",
                  "--second-color"
              );

        this.testData["menu_background_cart_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-cart-background-color",
                  this.testData["menu_background_cart_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-cart-background-color",
                  "--second-color"
              );
        this.testData["drop_menu_background_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-drob-down-menu-background-color",
                  this.testData["drop_menu_background_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-drob-down-menu-background-color",
                  "white"
              );
        this.testData["level1_text_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-1-color",
                  this.testData["level1_text_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-1-color",
                  "white"
              );
        this.testData["level1_hover_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-1-hover-color",
                  this.testData["level1_hover_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-1-hover-color",
                  "--menu-font-hover-color"
              );
        this.testData["level1_hover_color"]
            ? document.documentElement.style.setProperty(
                  "--menu-font-hover-color",
                  this.testData["level1_hover_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-1-hover-color",
                  "--menu-font-hover-color"
              );
        this.testData["level2_text_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-2-color",
                  this.testData["level2_text_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-2-color",
                  "--menu-font-hover-color"
              );
        this.testData["level2_hover_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-2-hover-color",
                  this.testData["level2_hover_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-2-hover-color",
                  "black"
              );
        this.testData["level3_text_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-3-color",
                  this.testData["level3_text_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-3-color",
                  "black"
              );
        this.testData["level3_hover_color"]
            ? document.documentElement.style.setProperty(
                  "--dynamic-menu-level-3-hover-color",
                  this.testData["level3_hover_color"]
              )
            : document.documentElement.style.setProperty(
                  "--dynamic-menu-level-3-hover-color",
                  "--menu-font-hover-color"
              );
    }
    
    navigateToLink(link: any, mainCategory?: any, levelOneItem?: any , itemType? :any) {
         if(link === '/'){
           link = ''
          }
          if(link === '/products/deals'){
            this.router.navigateByUrl(this.lang + link + '?sort=high-discount');
             return;
          }
        if( link ===  '/prescriptions' || link === "" || link === '/pages/branches'){
            this.router.navigateByUrl(this.lang + link);
        }
        else{
            if (link.includes("sub_category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "SubCategoryMenu", {
                name: params.sub_category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                description: params.sub_category_id,
            });
        } else if (link.includes("category_id")) {
            let params = <any>this.getParams(link);
            this.marketingService.fbTracking("track", "CategoryMenu", {
                name: params.category_id,
            });
            this.marketingService.snapTracking("track", "LIST_VIEW", {
                description: params.category_id,
            });
        }
        if (link.includes("http") || link.includes("www")) {
            //window.open(link, "_blank");
            window.location.href = link;
        } else if (link == "/") {
            this.router.navigate(["/"]);
        } 
        else {
            let path = link.split("?");
            let path2 = mainCategory ? mainCategory.split("?") : [];
            var queryParams = this.getLinkQueryParams(path[1]);
            var queryParams2 = mainCategory
                ? this.getLinkQueryParams(path2[1])
                : {};
            if (mainCategory && queryParams2.category_id) {
                queryParams["category_id"] = queryParams2.category_id;
            }

            if (queryParams.category_id && !queryParams.group_id) {
                this.handleCategoryRouting(queryParams);
            }
            if (queryParams.group_id) {
                this.handleGroupRouting(queryParams);
            } 
            if(queryParams.list_ids){
              this.handleCategoryRouting(queryParams);
            }
            else {
                if (
                    !queryParams["category_id"] &&
                    !queryParams["sub_category_id"] &&
                    !queryParams["group_id"] 
                ) {
                    let linkSlashCount = link.split('/').length - 1;
                    if(this.environmentVariables?.ENABLE_CATEGORY_VIEW && linkSlashCount  < 3){
                    this.router.navigate([this.lang + "/category/" + link])
                     }else{
                        this.router.navigate([this.lang + '/product/' + link]);
                    }
                     if(this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW && itemType == 'group' ){
                       this.router.navigate([this.lang + "/category/" + link])
                      }else if(!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW && itemType ==  'group' ){
                     this.router.navigate([this.lang + '/product/' + link]);
                        }
                }
            }
        }
        if (levelOneItem) {
            var levels = levelOneItem.level2;
            levelOneItem.level2 = [];

            setTimeout(() => {
                levelOneItem.level2 = levels;
            }, 100);
        }
        }
      

    
    }

    getLinkQueryParams(params: any = "") {
        let paramsArray = params.split("&");
        let paramsArrayWithValues: any[] = [];
        paramsArray.forEach((element: any) => {
            paramsArrayWithValues.push(element.split("="));
        });
        let queryParams: any = {};
        paramsArrayWithValues.forEach((element: any) => {
            queryParams[element[0]] = element[1];
        });
        return queryParams;
    }

    getParams(url: any) {
        var params = { pair: [""] };
        var parser = document.createElement("a");
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            params.pair[0] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    handleCategoryRouting(props: any) {
        if(this.environmentVariables.MENU_LINK_TYPE === 'slug') {
            if (
                !this.environmentVariables?.ENABLE_CATEGORY_VIEW ||
                props.sub_category_id
            ) {
                if(props.list_ids){
                    this.router.navigate(["/" + this.lang + "/products"], {
                        queryParams: props,
                    });
                } else {
                    this.onClickGA4MenuClickNavigationLevelEvent("/product/" + props.category_slug)
                    this.router.navigate(["/" + this.lang + "/product/" + props.category_slug], {
                    });
                }
            } else {
                this.onClickGA4MenuClickNavigationLevelEvent("/category/" + props.category_slug)
                this.router.navigate(["/" + this.lang + "/category/" + props.category_slug], {
                    // queryParams: queryParams,
                });
            }
        }else {
            if (
                !this.environmentVariables?.ENABLE_CATEGORY_VIEW ||
                props.sub_category_id
            ) {
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: props,
                });
            } else {
                this.router.navigate(["/" + this.lang + "/category"], {
                    queryParams: props,
                });
            }
       
        }
         
    }

    handleGroupRouting(props: any) {
        if(this.environmentVariables.MENU_LINK_TYPE === 'slug') {
            if (!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW) {
                    this.onClickGA4MenuClickNavigationLevelEvent("/product/" + props.category_slug + '/'+props.group_slug)
                    this.router.navigate(["/" + this.lang + "/product/" + props.category_slug + '/'+props.group_slug], {
                     });
                } else {
                    this.onClickGA4MenuClickNavigationLevelEvent("/category/" + props.category_slug + '/'+props.group_slug)
                    this.router.navigate(["/" + this.lang + "/category/" + props.category_slug + '/'+props.group_slug], {
                        // queryParams: queryParams,
                    });
                }
                
        }else {
            if (!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW) {
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: props,
                });
            } else {
                this.router.navigate(["/" + this.lang + "/category"], {
                    queryParams: props,
                });
            }
        }
    
    }

    handleSubCategoryRouting(props: any){
        if(this.environmentVariables.MENU_LINK_TYPE === 'slug') {
            if (!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW) {
                    this.onClickGA4MenuClickNavigationLevelEvent("/product/" + props.category_slug + '/'+props.group_slug +'/'+props.sub_category_slug)
                    this.router.navigate(["/" + this.lang + "/product/" + props.category_slug + '/'+props.group_slug +'/'+props.sub_category_slug], {
                     });
                  
                } else {
                    this.onClickGA4MenuClickNavigationLevelEvent("/category/" + props.category_slug + '/'+props.group_slug+'/'+props.sub_category_slug)
                    this.router.navigate(["/" + this.lang + "/category/" + props.category_slug + '/'+props.group_slug+'/'+props.sub_category_slug], {
                        // queryParams: queryParams,
                    });
                }
        }else {
            if (!this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW) {
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: props,
                });
            } else {
                this.router.navigate(["/" + this.lang + "/category"], {
                    queryParams: props,
                });
            }
        }
    }

    toggleCollapsedMenu(target: any){
        const targetMenu = document.querySelector(target);
        targetMenu.classList.toggle('d-block');
        const currentIcon = targetMenu.parentElement.querySelector('mat-icon');
        if(currentIcon)
            currentIcon.textContent = currentIcon.textContent.includes('expand_more') ? 'expand_less' : 'expand_more';
    }

    onClickGA4MenuClickNavigationLevelEvent(url:any){
        this.marketingService.GA4MenuClickNavigationLevelEvent(url)
    }
}
